import { getPackageType, PACKAGE_TYPE } from '../../helpers/getPackageType'

export function isHotelFlightPackage(bundleComponents) {
  const packageType = getPackageType(bundleComponents)
  return packageType === PACKAGE_TYPE.HOTEL_FLIGHT || packageType === PACKAGE_TYPE.HOTEL_FLIGHT_CAR
}

export function hasFirstCardIncrementalIncrease(listings = []) {
  const pricing = listings[0]?.fareBrands?.[0]?.pricing
  const amount = Number(pricing?.amountInFloat ?? pricing?.amount ?? 0)
  const isIncreaseText = pricing?.text !== '-' && pricing?.text !== 'Save'
  return amount > 0 && isIncreaseText
}

export function getVisiblePackageListings({ listings = [], recommendedListings = [], activeTabId } = {}) {
  if (activeTabId === 1 && recommendedListings.length > 0) {
    return recommendedListings
  }
  return listings
}

export function isIncrementalPriceVisible({ hasPriorPackageSelection = false, activeTabId } = {}) {
  return Boolean(hasPriorPackageSelection) || activeTabId > 1
}

export function isPackagePriceChangeBannerEligible({
  isPackageListings,
  bundleComponents,
  displayListings,
  showLoadingOverlay,
  listings,
  recommendedListings,
  activeTabId,
  hasPriorPackageSelection,
}) {
  const visibleListings = getVisiblePackageListings({
    listings,
    recommendedListings,
    activeTabId,
  })

  return (
    Boolean(isPackageListings) &&
    isHotelFlightPackage(bundleComponents) &&
    Boolean(displayListings) &&
    !showLoadingOverlay &&
    visibleListings?.length > 0 &&
    isIncrementalPriceVisible({ hasPriorPackageSelection, activeTabId }) &&
    hasFirstCardIncrementalIncrease(visibleListings)
  )
}
